let entityOldValues = {};

const attributeForButton = function (button) {
  return $(button).attr("id").replace("_button", "");
};

const textFieldForAttribute = function (attr) {
  return $("#entity_" + attr);
};

const transactionValueForAttribute = function (attr) {
  return $("#" + attr + "_new")
    .text()
    .trim();
};

const toggleCopyingValueFromTransaction = function (button) {
  let attr = attributeForButton(button);
  let textField = textFieldForAttribute(attr);
  let newValue;
  if ($(button).hasClass("btn-success")) {
    entityOldValues[attr] = textField.val();
    newValue = transactionValueForAttribute(attr);
    $(button).html(iconHtml("remove"));
  } else {
    newValue = entityOldValues[attr];
    $(button).html(iconHtml("menu-left"));
  }
  $(button).toggleClass("btn-success").toggleClass("btn-danger");
  textField.val(newValue);
};

const iconHtml = function (iconName) {
  return "<span class='glyphicon glyphicon-" + iconName + "' />";
};

const updateBatchSelectionForSession = function (newValue) {
  // save the selected value - this will be stored in the session
  $("#batch_selection_field").val(newValue);
  $("#batch_selection_field_updated").val("true");
};

const flagTransaction = function () {
  let reasonInput = $("input[data-flag-reason]");
  $(".spinner").show();
  url = reasonInput.attr("data-flag-url") + "?flag_reason=" + reasonInput.val();
  window.location = encodeURI(url);
};

// callback when new results appear in entity search modal
const initContributionDetailsButton = function (selector = "data-entity-id") {
  $("a[" + selector + "]").click(function () {
    const icon = $(this).find(".glyphicon");
    if (icon == null) {
      console.log("Couldn't load contribution detail");
    }
    icon
      .toggleClass("glyphicon-triangle-right")
      .toggleClass("glyphicon-triangle-bottom");
    $(".matched-entity-contributions-" + $(this).attr(selector)).toggle("fast");
    return false;
  });
};

const afterMatchContributorSearch = function () {
  initContributionDetailsButton("data-entity-search-entity-id");
  $("a[data-selected-entity-id]").click(function (event) {
    event.preventDefault();
    let selectedEntityId = $(event.target).attr("data-selected-entity-id");
    $.ajax({
      method: "PATCH",
      url: location.href.replace("match_contributor", "update_entity"),
      data: { entity_id: selectedEntityId },
    })
      .done(function (data) {
        $("table.match-contributor").show();
        $("input[type=hidden][name=entity_id]").val(selectedEntityId);
        $("#entity-search-modal").modal("hide");
      })
      .fail(function (error) {
        alert("Unable to store new entity - please try again.");
      });
  });
};

const setupEntityFieldCopyButtons = function () {
  $("a[data-edit-button]").each(function () {
    // if the text field is empty, and the transaction has a value, copy that over
    // as if the user had clicked the copy button
    let attr = attributeForButton(this);
    let textField = textFieldForAttribute(attr);
    let newValue = transactionValueForAttribute(attr);
    if (textField.val().length == 0 && newValue.length > 0) {
      toggleCopyingValueFromTransaction(this);
    }

    // set up the click handler for manual copying
    $(this).click(function () {
      toggleCopyingValueFromTransaction(this);
      return false;
    });
  });
};

$(function () {
  initContributionDetailsButton();

  setupEntityFieldCopyButtons();

  $("a[data-contributor-field-revealer]").click(function () {
    if ($(this).text().startsWith("More")) {
      $(".secondary-field").show();
      $(this).text("Less");
    } else {
      $(".secondary-field").hide();
      $(this).text("More...");
    }
    return false;
  });

  // user selected a new value in the batch deposit dropdown
  $("select[data-batch-selector]").change(function () {
    const newValue = $(this).val();
    if (newValue == "0") {
      // user selected "Add new"
      $("#new-batch-modal").modal();
      return;
    }
    updateBatchSelectionForSession(newValue);
  });

  $("a[data-flag-button]").click(function () {
    const flagForm = $("span[data-flag-form]");
    if (flagForm.is(":visible")) {
      flagForm.hide();
    } else {
      flagForm.show();
      $("input[data-flag-reason]").focus();
    }
    return false;
  });

  $("a[data-flag-submit]").click(function (event) {
    flagTransaction();
  });

  $("input[data-flag-reason]").keypress(function (event) {
    if (event.keyCode === 13) {
      // user hit enter
      flagTransaction();
    }
    if (event.keyCode === 27) {
      // user hit ESC
      $(event.target).val("");
      $(event.target).hide();
    }
  });

  $("input[data-match-contributor-search]").click(function (event) {
    event.preventDefault();
  });

  $("#entity-search-modal").on("shown.bs.modal", function (e) {
    $("#entity-search-last-name").focus();
  });

  $("input[data-entity-search-show-fields]").click(function (event) {
    event.preventDefault();
    $(event.target).hide();
    $(".expanded-form-element").show();
    $("#entity-search-last-name").focus();
  });
});

// Make functions globally available for inline scripts
window.afterMatchContributorSearch = afterMatchContributorSearch;
window.setupEntityFieldCopyButtons = setupEntityFieldCopyButtons;
window.initContributionDetailsButton = initContributionDetailsButton;
window.updateBatchSelectionForSession = updateBatchSelectionForSession;
